const aaa = [
    {
        path: "edit",
        component: () => import("@/views/msg/dingding/edit.vue"),
        meta: { title: '钉钉配置' },
    },
    {
        path: "list",
        component: () => import("@/views/msg/dingding/list.vue"),
        meta: { title: '钉钉模版' },
    },
]
export default aaa;